import { useState, useEffect } from 'react'
import { Alert, Table } from 'reactstrap'
import { handleGraphQLErrors } from '../../utils'
import { gql } from '@apollo/client'
import Spinner from '../Spinner/Spinner.js'
import { ALL_USER_ATTRIBUTES_QUERY } from '../../graphql.js'
import UserAttributeModal from './UserAttributeModal'
import UserAttributeRow from './UserAttributeRow'

export const ALL_USER_ATTRIBUTES = gql(ALL_USER_ATTRIBUTES_QUERY)

export default function UserAttributesGrid({ userId }) {
  console.log('UserAttributesGrid rendered: ', userId)

  const [showSpinner, setShowSpinner] = useState(false)
  const [attributeValues, setAttributeValues] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    async function fetchItems() {
      //console.log('UserAttributeGrid.useEffect')
      try {
        setShowSpinner(true)
        const { data, errors } = await window.apolloClient.query({ query: ALL_USER_ATTRIBUTES, variables: { userId: userId }, fetchPolicy: 'cache-first' })
        if (data.allUserAttributes) {
          //console.log(data.allUserAttributes)
          setAttributeValues(data.allUserAttributes)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setShowSpinner(false)
      }
    }
    if (userId) {
      fetchItems()
    } else {
      setAttributeValues([])
    }
  }, [userId])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger" style={{ marginTop: '50px'}}>{graphQLErrors[0].message}</Alert>
  } else if (showSpinner) {
    return <Spinner />
  } else if (attributeValues) {
    const rows = []
    for (let attribute of attributeValues) {
      rows.push(<UserAttributeRow key={attribute.id} attribute={attribute} />)
    }
    return (
      <div style={{ textAlign: 'center', padding: '10pxs' }}>
        <UserAttributeModal userId={userId} />
        <Table bordered size="sm" style={{ width: 'auto', margin: 'auto' }}>
          <thead>
            <tr>
              <th></th>
              <th>Attribute Name</th>
              <th>Default Value</th>
              <th>User Value</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </Table>
      </div>
    )
  }
  return ''
}
